export function isValidDecimalInput(value: string, decimalLimit: number = 2): boolean {
    const regex = new RegExp(`^(0|0\\.|\\d*\\.?\\d{0,${decimalLimit}})$`);
    
    return regex.test(value);
  }